// TODO clean this folder once it's fully rollout https://apglobal.atlassian.net/browse/IDENTITY-395
export * from './ConfirmCloseAccount'
